export function LegalLinks({ className, onClick }) {
	return (
		<>
			<a
				className={className}
				href="https://atelier.net/legal-information"
				target="_blank"
				rel={"noreferrer"}
				onClick={onClick}>
				<span>Legal Information</span>
			</a>
			<a
				className={className}
				href="https://atelier.net/data-protection-notice"
				target="_blank"
				rel={"noreferrer"}
				onClick={onClick}>
				<span>Data Protection Notice</span>
			</a>
			<a
				className={className}
				href="https://atelier.net/cookie-policy"
				target="_blank"
				rel={"noreferrer"}
				onClick={onClick}>
				<span>Cookie Policy</span>
			</a>
		</>
	);
}
